import { TEN_MINUTES_IN_MS } from '@protector/utils/constants';
import type { UUID } from '@protector/utils/types';
import { useQuery } from '@tanstack/react-query';
import { PropertyQueryKey } from './constants.ts';
import { getPropertyData, getProperties } from './services.ts';

export function useGetPropertyBasicInfo(propertyId?: string, enabled = true) {
  return useQuery({
    queryKey: [PropertyQueryKey.GET_PROPERTY_BASIC_INFO, propertyId],
    queryFn: () => getPropertyData(propertyId as UUID),
    staleTime: TEN_MINUTES_IN_MS,
    enabled: !!propertyId && enabled
  });
}

export function useGetProperties(workspaceId: string, orgIds?: string[], enabled = true) {
  return useQuery({
    queryKey: [PropertyQueryKey.GET_PROPERTIES, workspaceId, orgIds],
    queryFn: () => getProperties(workspaceId, orgIds),
    staleTime: TEN_MINUTES_IN_MS,
    enabled: !!workspaceId && enabled
  });
}
